import emotionTheme from '@/styles/theme'

// names generated from https://chir.ag/projects/name-that-color
export const BADGE_COLORS = {
  BUTTER_MILK: emotionTheme.ds.ColorBaseYellowLevel1,
  BUTTER_LIGHT: '#FFF8D9',
  ALTO: '#F5F5F5',
  SNOW_FLURRY: emotionTheme.ds.ColorBaseGreenLevel1,
  TANGERINE: '#F39000',
  SHAMROCK: '#2FD07B',
  POMEGRANATE: '#F54337',
  PEACH_SCHNAPPS: emotionTheme.ds.ColorBaseRedLevel1,
  ONAHAU: emotionTheme.ds.ColorBaseBlueLevel1,
  ALICE_BLUE: '#F0F4FA',
  MINE_SHAFT: '#1F1F1F',
  LIGHT_GREEN: '#DAFFC2',
  ZUMTHOR: '#EEF7FF',
  SERENADE: '#FFF7EB',
  LINEN: '#FCECEB',
  MUSTARD: '#FFEFAD',
  WHITE: '#FFFFFF',
}
